import { Spinner } from "@/components/ui/modal";
import { cn } from "@/utils/cn";
import { ComponentPropsWithoutRef, forwardRef } from "react";

interface LoadingButtonProps extends ComponentPropsWithoutRef<"button"> {
  className?: string;
}

const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(
          "flex items-center justify-center w-10 h-10 bg-white rounded-sm",
          className
        )}
        tabIndex={-1}
        {...props}
      >
        <Spinner className="w-6 h-6" />
      </button>
    );
  }
);

LoadingButton.displayName = "LoadingButton";

export default LoadingButton;
